import { useCallback } from "react";
import { useSnackbar } from "notistack";

const useNotification = () => {
    const { enqueueSnackbar } = useSnackbar();

    const showNotification = useCallback((message, variant = "default") => {
        if (message) {
            enqueueSnackbar(message, { variant });
        }
    }, [enqueueSnackbar]);

    return showNotification;
};

export default useNotification;
